import React from 'react';
import useSWR from "swr";
import {BillContainerState} from "../../../types";
import {BillSummary} from "./BillSummary";
import {Divider} from "primereact/divider";
import {TotalBillSummary} from "./TotalBillSummary";
import {Card} from "primereact/card";
import {Button} from "primereact/button";

export interface BillContainerSummaryProps {
  billContainerId: number;
}

export const BillContainerSummary = ({billContainerId}: BillContainerSummaryProps) => {
  const { data: states } = useSWR<BillContainerState[]>(`/bill_container_state/${billContainerId}`, {refreshInterval: 2000});
  const print = async () => {
      await fetch(`http://localhost:9099/bill_container_state/${billContainerId}/print`);
  }
  const footer = (
    <div>
      <Divider/>
      {!!states && (
        <TotalBillSummary states={states} />
      )}
    </div>
  );
  return (
    <Card className="h-full" subTitle="Bill Summary" title={!!states && !!states[0] ? states[0].billContainer.name : ''} footer={footer}>
        <Button style={{marginBottom:20}} label="Print" onClick={()=> print()} className="p-button-sm w-full" />
      <div>
        {!!states && states.map(state => (
          <BillSummary state={state} key={state.billContainerStateId} />
        ))}
      </div>
    </Card>
  );
};
